import { fetchAPI } from "../config/api";

export const fetchGame = (year, gameId, signal) =>
  fetchAPI(`/api/games/${year}/${gameId}`, { signal });
